/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationHierarchy
 */
export interface OrganizationHierarchy {
    /**
     * 
     * @type {string}
     * @memberof OrganizationHierarchy
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationHierarchy
     */
    parent_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationHierarchy
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationHierarchy
     */
    tenant_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationHierarchy
     */
    children_ids?: Array<string>;
    /**
     * The list of organizations or suborganizations that share user identities with this organization
     * @type {Array<string>}
     * @memberof OrganizationHierarchy
     */
    person_pool_orgs_ids?: Array<string>;
    /**
     * The list of organizations or suborganizations that share user groups with this organization
     * @type {Array<string>}
     * @memberof OrganizationHierarchy
     */
    group_pool_orgs_ids?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OrganizationHierarchy
     */
    manager_org_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationHierarchy
     */
    person_in_manager_org: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationHierarchy
     */
    inherits_rbac_pools: boolean;
}

/**
 * Check if a given object implements the OrganizationHierarchy interface.
 */
export function instanceOfOrganizationHierarchy(value: object): value is OrganizationHierarchy {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('person_in_manager_org' in value) || value['person_in_manager_org'] === undefined) return false;
    if (!('inherits_rbac_pools' in value) || value['inherits_rbac_pools'] === undefined) return false;
    return true;
}

export function OrganizationHierarchyFromJSON(json: any): OrganizationHierarchy {
    return OrganizationHierarchyFromJSONTyped(json, false);
}

export function OrganizationHierarchyFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationHierarchy {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'tenant_name': json['tenant_name'] == null ? undefined : json['tenant_name'],
        'children_ids': json['children_ids'] == null ? undefined : json['children_ids'],
        'person_pool_orgs_ids': json['person_pool_orgs_ids'] == null ? undefined : json['person_pool_orgs_ids'],
        'group_pool_orgs_ids': json['group_pool_orgs_ids'] == null ? undefined : json['group_pool_orgs_ids'],
        'manager_org_id': json['manager_org_id'] == null ? undefined : json['manager_org_id'],
        'person_in_manager_org': json['person_in_manager_org'],
        'inherits_rbac_pools': json['inherits_rbac_pools'],
    };
}

export function OrganizationHierarchyToJSON(json: any): OrganizationHierarchy {
    return OrganizationHierarchyToJSONTyped(json, false);
}

export function OrganizationHierarchyToJSONTyped(value?: OrganizationHierarchy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'parent_id': value['parent_id'],
        'name': value['name'],
        'tenant_name': value['tenant_name'],
        'children_ids': value['children_ids'],
        'person_pool_orgs_ids': value['person_pool_orgs_ids'],
        'group_pool_orgs_ids': value['group_pool_orgs_ids'],
        'manager_org_id': value['manager_org_id'],
        'person_in_manager_org': value['person_in_manager_org'],
        'inherits_rbac_pools': value['inherits_rbac_pools'],
    };
}

